<template>
	<header class="header">
        <b-container fluid class="cabecalho" style="padding-left: 0px; padding-right: 0px;">
            
            <b-row  no-gutters class="headerL1">
                <b-col cols="12" />
            </b-row>

            <mq-layout mq="sm+">
                <b-row  no-gutters class="headerL2">
                    <b-col sm="1" lg="1" order-sm="1" order-lg="1" />
                    <b-col sm="9" lg="3" order-sm="2" order-lg="2" class="text-sm-left text-lg-left">
                        <router-link to="/">
                            <b-img-lazy 
                                    :src="require('../../assets/hion-logo-header-191x67px-01.jpg')" 
                                    alt="Hion Tecnologia" 
                                    id="logo_hion">
                            </b-img-lazy>
                        </router-link>
                    </b-col>

                    <b-col sm="12" lg="6" order-sm="12" order-lg="5" class="text-sm-center text-lg-left">
                        <nav class="menu">
                            <ul>
                                <li class="botaoMenu">
                                    <router-link to="/">HOME</router-link>
                                </li>
                                <li class="botaoMenu">
                                    <router-link to="/Sobre">SOBRE NÓS</router-link>
                                </li>
                                <li class="dropdown">
                                    <vue-dropdown :config="config"
                                        @setSelectedOption="setNewSelectedOption($event);">
                                    </vue-dropdown>
                                </li>
                                <li class="botaoMenu">
                                    <router-link to="/Contatos">CONTATO</router-link>
                                </li>
                            </ul>
                        </nav>
                    </b-col>

                    <b-col sm="2" lg="2" order-sm="10" order-lg="11">
                        <router-link to="/Login" class="bot-login" v-if="!usuario"
                            v-b-tooltip.bottom="{ variant: 'info' }"
                            title="Efetuar Login"><center>
                                <i class="fas fa-2x fa-unlock-alt"></i>
                                <p>LOGIN</p></center>
                        </router-link>
                        <avatarDropdown v-else />
                    </b-col>
                </b-row>
            </mq-layout>

            <mq-layout mq="xs">
                <b-row  no-gutters class="headerL2">
                    <b-col cols="12" class="text-center">
                        <router-link to="/">
                            <b-img-lazy 
                                    :src="require('../../assets/logo_bola_preto.jpg')" 
                                    alt="Logotipo Tela Pequena" 
                                    class="logoBolaPreto">
                            </b-img-lazy>
                        </router-link>
                    </b-col>    
                </b-row>
            </mq-layout>

            <mq-layout mq="xs">
                <b-row  no-gutters class="headerL1" align-v="center">
                    <b-col cols="12" class="text-center">
                        <button class="menu-toogle" id="menu-toogle-id"
                            v-b-toggle.collapse-1>
                                <i class="fas fa-2x fa-bars text-center"></i>
                        </button>
                    </b-col>
                </b-row>

                <b-collapse id="collapse-1" class="mt-0">
                    <mq-layout mq="xs"><b-card class="cardSmall">
                        <nav class="menuSmall">
                            <router-link to="/Login" v-if="!usuario">
                                <button class="botoesSmall" v-b-toggle.collapse-1 @click="topFunction">
                                    <li class="iconesSmall">
                                        <i class="fab fa-expeditedssl"></i>
                                    </li>
                                    <li class="textoIconeSmall">
                                        LOGIN PLATAFORMA HION
                                    </li>
                                </button>
                            </router-link>
                            <button class="botoesSmall"  v-b-toggle.collapse-2-inner size="sm" v-else>
                                <li class="iconesSmall-img">
                                    <img id="user-avatarMenuSmall"
                                        :src="require('@/thumbler/' + usuario.foto)"
                                        alt="Avatar do Perfil" 
                                    />
                                </li>
                                <li class="textoIconeSmall">
                                    {{limitaNomeMenuSmall}} <i id="seta-inner2" class="fas fa-angle-down"></i>
                                </li>
                                
                                <b-collapse id="collapse-2-inner" class="mt-2">
                                    <mq-layout mq="xs"><b-card class="cardSmall">
                                        <nav class="menuSmall">
                                            <button class="botoesSmall" v-b-toggle.collapse-1 @click.prevent="goHome_menuXS">
                                                <li class="iconesSmallsub">
                                                    <i class="fas fa-house-user"></i>
                                                </li>
                                                <li class="textoIconeSmall">
                                                    PÁGINA INICIAL
                                                </li>
                                            </button>

                                            <button class="botoesSmall" v-b-toggle.collapse-1 @click="topFunction">
                                                <li class="iconesSmallsub">
                                                    <i class="far fa-address-card"></i>
                                                </li>
                                                <li class="textoIconeSmall">
                                                    EDITAR PERFIL
                                                </li>                                                    
                                            </button>
                                            
                                            <button class="botoesSmall" v-b-toggle.collapse-1 @click="topFunction">
                                                <li class="iconesSmallsub">
                                                    <i class="fas fa-user-cog"></i>
                                                </li>
                                                <li class="textoIconeSmall">
                                                    CONFIGURAÇÕES
                                                </li>                                                    
                                            </button>

                                            <button class="botoesSmall" v-b-toggle.collapse-1 @click.prevent="logout_menuXS">
                                                <li class="iconesSmallsub">
                                                    <i class="fas fa-sign-out-alt"></i>
                                                </li>
                                                <li class="textoIconeSmall">
                                                    SAIR
                                                </li>                                                    
                                            </button>
                                        </nav>
                                    </b-card></mq-layout>
                                </b-collapse>
                            </button>

                            <router-link to="/">
                                <button class="botoesSmall" v-b-toggle.collapse-1>
                                        <li class="iconesSmall">
                                            <i class="fas fa-home"></i>
                                        </li>
                                        <li class="textoIconeSmall">
                                            HOME
                                        </li>
                                </button>
                            </router-link>
                            <router-link to="/Sobre">
                                <button class="botoesSmall" v-b-toggle.collapse-1>
                                        <li class="iconesSmall">
                                            <i class="fas fa-users"></i>
                                        </li>
                                        <li class="textoIconeSmall">
                                            SOBRE NÓS
                                        </li>                                    
                                </button>
                            </router-link>
                            <button class="botoesSmall"  v-b-toggle.collapse-1-inner size="sm">
                                <li class="iconesSmall">
                                    <i class="fas fa-charging-station"></i>
                                </li>
                                <li class="textoIconeSmall">
                                    SOLUÇÕES E TECNOLOGIA <i id="seta-inner1" class="fas fa-angle-down"></i>
                                </li>
                                
                                <b-collapse id="collapse-1-inner" class="mt-2">
                                    <mq-layout mq="xs"><b-card class="cardSmall">
                                        <nav class="menuSmall">
                                            <router-link to="/Agro">
                                                <button class="botoesSmall" v-b-toggle.collapse-1 @click="topFunction">
                                                    <li class="iconesSmallsub">
                                                        <i class="fas fa-tractor"></i>
                                                    </li>
                                                    <li class="textoIconeSmall">
                                                        AGRO 4.0
                                                    </li>
                                                </button>
                                            </router-link>
                                            <router-link to="/Tecnologia">
                                                <button class="botoesSmall" v-b-toggle.collapse-1 @click="topFunction">
                                                    <li class="iconesSmallsub">
                                                        <i class="fas fa-car-battery"></i>
                                                    </li>
                                                    <li class="textoIconeSmall">
                                                        BATERIA HION
                                                    </li>                                                    
                                                </button>
                                            </router-link>
                                            <router-link to="/KinderBMS">
                                                <button class="botoesSmall" v-b-toggle.collapse-1 @click="topFunction">
                                                    <li class="iconesSmallsub">
                                                        <i class="fas fa-bolt"></i>
                                                    </li>
                                                    <li class="textoIconeSmall">
                                                        BMS HION
                                                    </li>                                                    
                                                </button>
                                            </router-link>
                                            <router-link to="/Drones">
                                                <button class="botoesSmall" v-b-toggle.collapse-1 @click="topFunction">
                                                    <li class="iconesSmallsub">
                                                        <i class="fas fa-plane"></i>
                                                    </li>
                                                    <li class="textoIconeSmall">
                                                        DRONES
                                                    </li>                                                    
                                                </button>
                                            </router-link>
                                            <router-link to="/Eletromobilidade">
                                                <button class="botoesSmall" v-b-toggle.collapse-1 @click="topFunction">
                                                    <li class="iconesSmallsub">
                                                        <i class="fas fa-car"></i>
                                                    </li>
                                                    <li class="textoIconeSmall">
                                                        ELETROMOBILIDADE
                                                    </li>                                                    
                                                </button>
                                            </router-link>
                                            <router-link to="/Empilhadeiras">
                                                <button class="botoesSmall" v-b-toggle.collapse-1 @click="topFunction">
                                                    <li class="iconesSmallsub">
                                                        <i class="fas fa-industry"></i>
                                                    </li>
                                                    <li class="textoIconeSmall">
                                                        EMPILHADEIRAS
                                                    </li>                                                    
                                                </button>
                                            </router-link>
                                            <router-link to="/EnergiaRenovavel">
                                                <button class="botoesSmall"  v-b-toggle.collapse-1 @click="topFunction">
                                                    <li class="iconesSmallsub">
                                                        <i class="fas fa-sun"></i>
                                                    </li>
                                                    <li class="textoIconeSmall">
                                                        ENERGIA RENOVÁVEL
                                                    </li>                                                    
                                                </button>
                                            </router-link>
                                            <router-link to="/EnergyStorage">
                                                <button class="botoesSmall" v-b-toggle.collapse-1 @click="topFunction">
                                                    <li class="iconesSmallsub">
                                                        <i class="fas fa-battery-three-quarters"></i>
                                                    </li>
                                                    <li class="textoIconeSmall">
                                                        ENERGY STORAGE
                                                    </li>                                                    
                                                </button>
                                            </router-link>
                                            <router-link to="/Hospitalar">
                                                <button class="botoesSmall" v-b-toggle.collapse-1 @click="topFunction">
                                                    <li class="iconesSmallsub">
                                                        <i class="fas fa-procedures"></i>
                                                    </li>
                                                    <li class="textoIconeSmall">
                                                        HOSPITALAR
                                                    </li>                                                    
                                                </button>
                                            </router-link>
                                            <router-link to="/Industria">
                                                <button class="botoesSmall" v-b-toggle.collapse-1 @click="topFunction">
                                                    <li class="iconesSmallsub">
                                                        <i class="fas fa-industry"></i>
                                                    </li>
                                                    <li class="textoIconeSmall">
                                                        INDUSTRIA 4.0
                                                    </li>                                                    
                                                </button>
                                            </router-link>
                                            <router-link to="/Maritima">
                                                <button class="botoesSmall" v-b-toggle.collapse-1 @click="topFunction">
                                                    <li class="iconesSmallsub">
                                                        <i class="fas fa-ship"></i>
                                                    </li>
                                                    <li class="textoIconeSmall">
                                                        MARÍTIMA
                                                    </li>                                                    
                                                </button>
                                            </router-link>
                                            <router-link to="/Militar">
                                                <button class="botoesSmall" v-b-toggle.collapse-1 @click="topFunction">
                                                    <li class="iconesSmallsub">
                                                        <i class="fas fa-fighter-jet"></i>
                                                    </li>
                                                    <li class="textoIconeSmall">
                                                        MILITAR
                                                    </li>                                                    
                                                </button>
                                            </router-link>
                                            <router-link to="/SmartHomes">
                                                <button class="botoesSmall" v-b-toggle.collapse-1 @click="topFunction">
                                                    <li class="iconesSmallsub">
                                                        <i class="fas fa-home"></i>
                                                    </li>
                                                    <li class="textoIconeSmall">
                                                        SMART HOMES
                                                    </li>                                                    
                                                </button>
                                            </router-link>
                                            <router-link to="/Telecomunicacoes">
                                                <button class="botoesSmall" v-b-toggle.collapse-1 @click="topFunction">
                                                    <li class="iconesSmallsub">
                                                        <i class="fas fa-network-wired"></i>
                                                    </li>
                                                    <li class="textoIconeSmall">
                                                        TELECOMUNICAÇÕES
                                                    </li>                                                    
                                                </button>
                                            </router-link>
                                        </nav>
                                    </b-card></mq-layout>
                                </b-collapse>
                            </button>
                            <router-link to="/Contatos">
                                <button class="botoesSmall"  v-b-toggle.collapse-1 @click="topFunction">
                                        <li class="iconesSmall">
                                            <i class="fas fa-phone-volume"></i>
                                        </li>
                                        <li class="textoIconeSmall">
                                            CONTATO
                                        </li>                                       
                                </button>
                            </router-link>
                        </nav>
                    </b-card></mq-layout>
                </b-collapse>
            </mq-layout>
        </b-container>

        <BotaoScrollTopo class="BotaoTopo" />

	</header>
</template>

<script>
import { userKey } from '../../global'
import { mapState } from 'vuex'
import { ekarApyaba } from '../../config/piht/cv.js'

export default {
    name: "Header",
    components: { 
        vueDropdown: () => import(/* webpackChunkName: "vueDropdown" */ "../efeitos/dropdown"),
        avatarDropdown: () => import(/* webpackChunkName: "avatarDropdown" */ "../efeitos/avatar"),
        BotaoScrollTopo: () => import(/* webpackChunkName: "BotaoScrollTopo" */ "../efeitos/BotaoScroll")
    },
    computed: {
        ...mapState(['usuario']),
        limitaNomeMenuSmall: function () {
            const entrada = this.usuario.apelido ? this.usuario.apelido : this.usuario.nome_razao;
            let saida = '';

            if(entrada.length >= 32) {
                saida = entrada.substring(0, 31);
                saida += "...";
            } else saida = entrada;

            const Maiscula = saida.toUpperCase();
            
            return Maiscula
        },
    },
    props: {
    
    },
    data: function() {
        return {
            config: {
                options: [
                {
                    value: "AGRO 4.0",
                    icon: 'fas fa-tractor',
                    rota: '/Agro'
                },
                {
                    value: "BATERIAS HION",
                    icon: 'fas fa-car-battery',
                    rota: '/Tecnologia'
                },
                {
                    value: "BMS HION",
                    icon: 'fas fa-bolt',
                    rota: '/KinderBMS'
                },
                {
                    value: "DRONES",
                    icon: 'fas fa-plane',
                    rota: '/Drones'
                },
                {
                    value: "ELETROMOBILIDADE",
                    icon: 'fas fa-car',
                    rota: '/Eletromobilidade'
                },
                {
                    value: "EMPILHADEIRAS",
                    icon: 'fas fa-industry',
                    rota: '/Empilhadeiras'
                },
                {
                    value: "ENERGIA RENOVÁVEL",
                    icon: 'fas fa-sun',
                    rota: '/EnergiaRenovavel'
                },
                {
                    value: "ENERGY STORAGE",
                    icon: 'fas fa-battery-three-quarters',
                    rota: '/EnergyStorage'
                },
                {
                    value: "HOSPITALAR",
                    icon: 'fas fa-procedures',
                    rota: '/Hospitalar'
                },
                {
                    value: "INDUSTRIA 4.0",
                    icon: 'fas fa-industry',
                    rota: '/Industria'
                },
                {
                    value: "MARÍTIMA",
                    icon: 'fas fa-ship',
                    rota: '/Maritima'
                },
                {
                    value: "MILITAR",
                    icon: 'fas fa-fighter-jet',
                    rota: '/Militar'
                },
                {
                    value: "SMART HOMES",
                    icon: 'fas fa-home',
                    rota: '/SmartHomes'
                },
                {
                    value: "TELECOMUNICAÇÕES",
                    icon: 'fas fa-network-wired',
                    rota: '/Telecomunicacoes'
                }
                ],
                placeholder: "SOLUÇÕES E TECNOLOGIA",
                backgroundColor: "#000",
                textColor: "#eee",
                borderRadius: "12px",
                border: "solid 2px #008fac",
                width: 200
            }
        };
    },
    methods: {
        setNewSelectedOption(selectedOption) {
        this.config.placeholder = selectedOption.value;
        },
        topFunction() {
            document.body.scrollTop = 0
            document.documentElement.scrollTop = 0
        },
        logout_menuXS() {
            this.$root.$emit('bv::toggle::collapse', 'collapse-1') //Fecha o b-vue collapse /////////

            this.topFunction();                     //garante que a tela role para o topo ///////////
            //Efetua logout /////////////////////////////////////////////////////////////////////////
            localStorage.removeItem(userKey)
            this.$store.commit('setUser', null)
            this.$router.push({ name: 'Auth' })
        },
        goHome_menuXS() {
            //Avalia qual página da requisição para saber se fecha ou efetua toggle no b-vue collapse
            const pagAtual = this.$router.currentRoute.path.substring(0, 15);
            if (pagAtual === '/PlataformaHION') {
                this.$root.$emit('bv::hide::collapse', 'collapse-1')
            } else {
                this.$root.$emit('bv::toggle::collapse', 'collapse-1')
            } ///////////////////////////////////////////////////////////////////////////////////////
            
            this.topFunction();                     //garante que a tela role para o topo /////////
            
            ekarApyaba(this.usuario , this.$router.currentRoute.path);//executa acao de ctrl //////
            if(this.$mq === 'xs') {
                this.$nextTick(function () {
                    this.$store.commit('alternaMenu', false);
                });
            }
            ///////////////////////////////////////////////////////////////////////////////////////
        },
        fecharMenuXS() {    //ouvinte do click para fechar menu se clicou fora
            const collapseConteudo = document.getElementById("collapse-1");
            const botaoMenuTootgle = document.getElementById('menu-toogle-id');

            const ClicouCollapse1 = collapseConteudo.contains(event.target);
            const ClicouBotao = botaoMenuTootgle.contains(event.target);

            if(!ClicouBotao)   {  //so executa de clicou fora do botao
                if(!ClicouCollapse1) { //So executa se clicou fora do menu Toogle Small
                    //Se clicou fora efetua o fechamento do menu Toogle Small
                    this.$root.$emit('bv::toggle::collapse', 'collapse-1');
                }
            }
        }
    },
    mounted() {
        this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
            if (collapseId === 'collapse-1' && isJustShown === true) {
                window.addEventListener('click', this.fecharMenuXS);
            }
            if (collapseId === 'collapse-1' && isJustShown === false) {
                window.removeEventListener('click', this.fecharMenuXS);
            }
            if (collapseId === 'collapse-1-inner' && isJustShown === true) {
                const ctrlSeta = document.getElementById("seta-inner1");
                ctrlSeta.classList.remove("fa-angle-down");
                ctrlSeta.classList.add("fa-angle-up");
            }
            if (collapseId === 'collapse-1-inner' && isJustShown === false) {
                const ctrlSeta = document.getElementById("seta-inner1");
                ctrlSeta.classList.remove("fa-angle-up");
                ctrlSeta.classList.add("fa-angle-down");
            }
            if (collapseId === 'collapse-2-inner' && isJustShown === true) {
                const ctrlSeta = document.getElementById("seta-inner2");
                ctrlSeta.classList.remove("fa-angle-down");
                ctrlSeta.classList.add("fa-angle-up");
            }
            if (collapseId === 'collapse-2-inner' && isJustShown === false) {
                const ctrlSeta = document.getElementById("seta-inner2");
                ctrlSeta.classList.remove("fa-angle-up");
                ctrlSeta.classList.add("fa-angle-down");
            }
        })
    },
}
</script>

<style>
    .header {
        grid-area: header;
        background-color: #000;
        z-index: 6;
        height: 225px;
        font-family: "Raleway", sans-serif;
    }
    #collapse-1 {
        z-index: 6;
    }

    .BotaoTopo {
        position: fixed;
        left: calc(100% - 50px);
        top: calc(100% - 100px);
        z-index: 8;
    }

    .cabecalho {
        margin:0;
    }

    .headerL1 {
        margin:0;
        height: 70px;
    }

    .headerL2 {
        margin:0;
        height: 85px;
    }

    #logo_hion {
        padding-top: 10px;
    }

    .logoBolaPreto {
        width: 85px;
        height: 85px;
    }

    .menu {
        display: inline-block;
        vertical-align: top;
        padding-top: 24px;   
    }

    .menu ul {
        margin: 0;
        padding: 0;
    }

    .menu li {
        display: inline-block;
        padding: 0px 8px;
    }

    .menu a {
        text-decoration: none;
        color: #eee;
        padding: 7px; 
    }

    .menu a:hover {
        text-decoration: none;
        color: #eee;
    }

    .botaoMenu {
        font-size: 0.72em;
    }

    .botaoMenu:hover a {
        border: solid 2px #008fac;
        border-radius: 12px;
    }

    .bot-login {
        text-decoration: none;
        font-family: "Play";
        color: #eee;
        font-size: 0.8em;
        display: inline-block;
        padding-top: 24px;
        padding-left: 5px;
        padding-right: 5px;
    }

    .bot-login p {
        font-size: 0.9em;
    }

    .bot-login i {
        color: #008fac;
    }

    .bot-login:hover {
        text-decoration: none;
        color: #ffd618;
    }

    .bot-login:hover i {
        color: #eee;
    }

/***** Opções para o MENU TOOGLE para telas SMALL **********************/
    .menu-toogle:enabled {
        outline:none;
        border: none;
    }

    .menu-toogle {
        color: #eee;
        background-color: #000;
        border: none;
        border-radius: 15px;
        height: 50px;
        width: 50px;
        padding: 0;
        margin: 0;
    }
 
    .menu-toogle:hover {
        border: solid 2px #008fac;
    }

    #collapse-1 {
        position:relative;
    }
    
    .botoesSmall {
        width: 100%;
        border: none;
        color: #2e2d2c;
        font-size: 13px;
        font-weight: bold;
        background-color: #fff;
        border-radius: 10px;
        text-align: left !important;
        min-height: 43px;
        padding: 3px;
    }
    .botoesSmall:hover {
       background-color: #008fac;
       color: #eee;
       text-decoration: none;
    }
    .botoesSmall:hover .iconesSmall {
        color: #2e2d2c;
    }
     .botoesSmall:hover > .iconesSmallsub {
        color: #2e2d2c;
    }
    .botoesSmall:enabled {
        outline:none;
        border: none;
    }
    .textoIconeSmall {
        display: table-cell;
        vertical-align: middle;
        text-decoration: none;
        letter-spacing: 1px;
        padding-left: 5px;
    }
 
    .iconesSmall {
        display: table-cell;
        vertical-align: middle;
        font-size: 25px;
        color: #008fac;
        width: 32px;
        height: 32px;
    }

    .iconesSmall-img {
        display: table-cell;
        vertical-align: middle;
        width: 32px;
        height: 32px;
        border-radius: 32px;
    }
    #user-avatarMenuSmall {
        width: 32px;
        height: 32px;
        border-radius: 32px;
    }

    .iconesSmallsub {
        display: table-cell;
        vertical-align: middle;
        font-size: 25px;
        color: #008fac;
        min-width: 32px;
    }
    /*********************************************************************/

/* MEDIA QUERY SM E MD *********************************************************/
@media (min-width: 576px) and (max-width:991px) { /* MD E SM */



}

/* MEDIA QUERY XS ****************************************************/
@media (max-width:575px) { /* XS */


}

</style>